import { Container, Row, Col } from "react-bootstrap";
import LiveSessionCard from "../../../Components/ui/LiveSessionCard/LiveSessionCard";
import facebookIcon from "../../../assets/icons/facebook.svg";
import doctorImg from "../../../assets/images/livesessionvideo-left.jpeg";
import slideImg1 from "../../../assets/images/livesessionvideo-right-1.jpeg";
import slideImg2 from "../../../assets/images/livesessionvideo-right-2.jpeg";
import slideImg3 from "../../../assets/images/livesessionvideo-right-3.jpeg";
import "./livesesstionvideo.css";

/* ─── Static data (replace with API response later) ─── */
const HOST_CARD = {
  image: doctorImg,
  badge: true,
  platformIcon: facebookIcon,
  topic: "Mental Health",
  doctorName: "Dr. John Smith",
  onRegister: () => console.log("Host register clicked"),
};

const SESSIONS = [
  {
    image: slideImg1,
    priority: "Our Priority",
    title: "A Free Consultation",
    date: "Friday, April 15th, 2022",
    time: "10AM - 4PM",
    location: "Site Grounds, Lagos",
    onRegister: () => console.log("Session 1 register"),
  },
  {
    image: slideImg2,
    priority: "Our Priority",
    title: "Expert Health Talk",
    date: "Saturday, May 20th, 2022",
    time: "9AM - 1PM",
    location: "City Hall, Abuja",
    onRegister: () => console.log("Session 2 register"),
  },
  {
    image: slideImg3,
    priority: "Our Priority",
    title: "Wellness Workshop",
    date: "Sunday, June 5th, 2022",
    time: "11AM - 3PM",
    location: "Health Centre, Ikeja",
    onRegister: () => console.log("Session 3 register"),
  },
];

export const Livesesstionvideo = () => {
  return (
    <section className="lsv-section">
      <Container fluid="xl">
        <Row className="mb-4">
          <Col>
            <h2 className="lsv-heading">Live Sessions – Join Now!</h2>
            <p className="lsv-subtext">
              Our expert doctors will be going live soon to answer your
              questions and share valuable health insights. Stay tuned for the
              next session.
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            <LiveSessionCard hostCard={HOST_CARD} sessions={SESSIONS} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
